module.exports = __webpack_public_path__ + "img/sld_scb_14_t1_green.eda0aecb.svg";